import React from "react";
import { FilePlus2 } from "lucide-react";

const EmptyState = ({ theme, isRTL, title, description, actionLabel, onAction }) => {
  const isDark = theme === "dark";
  const stroke = isDark ? "rgba(148,163,184,0.5)" : "rgba(100,116,139,0.4)";
  const fill = isDark ? "rgba(59,130,246,0.08)" : "rgba(59,130,246,0.06)";

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "56px 24px", textAlign: "center" }}>
      <svg width="140" height="110" viewBox="0 0 140 110" fill="none" style={{ marginBottom: 20 }}>
        <rect x="20" y="14" width="70" height="86" rx="10" fill={fill} stroke={stroke} strokeWidth="2" />
        <line x1="32" y1="34" x2="78" y2="34" stroke={stroke} strokeWidth="2.5" strokeLinecap="round" />
        <line x1="32" y1="48" x2="78" y2="48" stroke={stroke} strokeWidth="2.5" strokeLinecap="round" />
        <line x1="32" y1="62" x2="60" y2="62" stroke={stroke} strokeWidth="2.5" strokeLinecap="round" />
        <circle cx="98" cy="76" r="26" fill={isDark ? "rgba(59,130,246,0.15)" : "rgba(59,130,246,0.1)"} stroke="#3b82f6" strokeWidth="2" />
        <line x1="98" y1="64" x2="98" y2="88" stroke="#3b82f6" strokeWidth="3" strokeLinecap="round" />
        <line x1="86" y1="76" x2="110" y2="76" stroke="#3b82f6" strokeWidth="3" strokeLinecap="round" />
      </svg>
      <h3 style={{ margin: "0 0 8px 0", fontSize: 16, fontWeight: 700, color: isDark ? "#f1f5f9" : "#1e293b" }}>{title}</h3>
      <p style={{ margin: "0 0 20px 0", fontSize: 13, maxWidth: 320, lineHeight: 1.5, color: isDark ? "rgba(255,255,255,0.5)" : "rgba(30,41,59,0.55)" }}>{description}</p>
      {onAction && (
        <button
          type="button"
          onClick={onAction}
          style={{
            display: "flex", alignItems: "center", gap: 8, padding: "10px 20px", borderRadius: 12, border: "none",
            background: "linear-gradient(135deg, #3b82f6, #2563eb)", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer",
            flexDirection: isRTL ? "row-reverse" : "row",
          }}
        >
          <FilePlus2 size={15} /> {actionLabel}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
